<template>
  <div class="memberRebate min-height">
    <div class="mTop">
      <div
        v-for="item in topData"
        :key="item.id"
        class="mTopBtn"
        :class="{ act: topActive == item.id }"
        size="medium"
        @click="topActive = item.id"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="memberContent">
      <RebateDisCodeVue
        v-if="topActive == 0"
        @ViewDetails="topActive = 1"
      ></RebateDisCodeVue>
      <IncomeDataVue v-if="topActive == 1"></IncomeDataVue>
    </div>
  </div>
</template>

<script>
import IncomeDataVue from "./incomeData.vue";
import RebateDisCodeVue from "./rebateDisCode.vue";

export default {
  components: {
    IncomeDataVue,
    RebateDisCodeVue,
  },
  created() {
    const userInfo = this.$store.state.userInfo || {};
    const shortswitch = userInfo?.switchs?.short_url_switch == 1;
    if(!shortswitch) {
      this.$router.push({ name: "drive" });
    }
  },
  data() {
    return {
      topData: [
        { id: 0, name: this.$t("Fm2shortlinkbate.Fm2link") },
        { id: 1, name: this.$t("Fm2shortlinkbate.dataDetails") },
      ],
      topActive: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.memberRebate {
  background: #f7f7f7;
  .memberContent {
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 32px 24px;
    min-height: calc(100vh - 50px - 20px - 30px - 36px - 18px);
  }
}
</style>
